export default function CsCertificate() {
  return (
    <h2>Cs Certificate</h2>
  );
}
